import { format } from "date-fns";
import api from "../services/api";

interface IPartialResponse {
    codeResult: string;
    data: any[];
}

export interface IPartialMonthSectorParams {
    year: string;
    month: string;
    agentId: string;
    tipo: string;
    comVendas: string;

}
export interface IPartialMonthSector {    
    representante: string;
    quantidade: number;
    totalVendas: number;
    totalReceber: number;
    totalRecebido: number;
    credDeb: number;
    empresa: number;
    faltam: number;
}


class PartialSectorRepository {
    public async PartialMonthSector({ year, month, agentId, tipo, comVendas }: IPartialMonthSectorParams): Promise<IPartialMonthSector[]> {
        const initialDate = format(new Date(parseInt(year), parseInt(month) - 1, 1, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");
        const endDate = format(new Date(parseInt(year), parseInt(month), 1, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");

        const body = {
            "tables": ["Conference", "Representante", "Kit", "Pedido"],
            "sql": [
                {
                    "coderesult": "Parcial",
                    "query": `SELECT Representante.nome as Representante, 
                    COUNT(Conference.kitId) as Qtd, 
                    SUM(Conference.valorVendido) as TotalVendas, 
                    SUM(Conference.valorReceber) as TotalReceber, 
                    SUM(Conference.valorRecebido) as TotalRecebido, 
                    (SUM(Conference.valorRecebido) - SUM(Conference.valorReceber)) as CredDeb, 
                    (SUM(Conference.valorRecebido) - SUM(Conference.comissaoRepresentante)) as Empresa 
                    FROM Conference 
                    INNER JOIN Representante 
                    ON Representante.id = Conference.representanteId                     
                    INNER JOIN Kit 
                    ON Kit.id = Conference.kitId 
                    WHERE Conference.data >= "${initialDate}" 
                    AND Conference.data < "${endDate}" 
                    AND Conference.conferenceType = 0 
                    AND Kit.tipo IN(${tipo})
                    ${comVendas != "AMBOS" ? `AND Conference.valorVendido ${comVendas} ` : ""}
                    ${agentId.length > 0 ? `AND Representante.id = '${agentId}' ` : ""}
                    GROUP BY Representante.nome 
                    ORDER BY Representante`
                },
                {
                    "coderesult": "Faltam",
                    "query": `SELECT COUNT(Kit.id) as Faltam 
                    FROM Kit 
                    INNER JOIN Pedido 
                    ON Pedido.id = Kit.pedidoId 
                    WHERE Kit.statusKit = 3 
                    AND Pedido.acerto >= "${initialDate}" 
                    ${agentId.length > 0 ? `AND Pedido.representanteId = '${agentId}' ` : ""}
                    AND Pedido.acerto < "${endDate}"`
                },
            ]
        };

        const response = await api.post<IPartialResponse[]>("reports", body);
        console.log(response);
        return this.GetFromCodeResult(response.data, "Parcial").map(result => {
            return {
                representante: result.Representante,
                quantidade: result.Qtd,
                totalVendas: result.TotalVendas,
                totalReceber: result.TotalReceber,
                totalRecebido: result.TotalRecebido,
                credDeb: result.CredDeb,
                empresa: result.Empresa,
                faltam: this.GetFromCodeResult(response.data, "Faltam")[0].Faltam
            }
        });
    }

    GetFromCodeResult(data: IPartialResponse[], codeResult: string) {

        return data.find(result => result.codeResult === codeResult)?.data || [];
    }
}

const partialSectorRepository = new PartialSectorRepository();
export default partialSectorRepository;